type SnapCallbacks = {
  onPull: (distance: number) => void;
  onThreshold: () => void;
  onRelease: () => void;
};

export const useTopSnapBack = (
  container: HTMLElement,
  { onPull, onThreshold, onRelease }: SnapCallbacks
) => {
  const overscrollThreshold = 250;

  let startY = 0;
  let overscroll = 0;

  const onTouchStart = (e: TouchEvent) => {
    if (container.scrollTop <= 0) {
      startY = e.touches[0].clientY;
      overscroll = 0;
      onPull(0);
    }
  };

  const onTouchMove = (e: TouchEvent) => {
    if (container.scrollTop <= 0) {
      const currentY = e.touches[0].clientY;
      overscroll = Math.max(0, currentY - startY);

      onPull(overscroll);

      if (overscroll > overscrollThreshold) {
        onThreshold();
      }
    }
  };

  const onTouchEnd = () => {
    onRelease();
    overscroll = 0;
  };

  container.addEventListener("touchstart", onTouchStart, { passive: true });
  container.addEventListener("touchmove", onTouchMove, { passive: true });
  container.addEventListener("touchend", onTouchEnd);

  return () => {
    container.removeEventListener("touchstart", onTouchStart);
    container.removeEventListener("touchmove", onTouchMove);
    container.removeEventListener("touchend", onTouchEnd);
  };
};